/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Observable} from 'rxjs/Observable';
import {HttpRequest} from './request';
import {HttpEvent} from './response';
/**
 * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
 * `HttpResponse`.
 * 
 * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
 * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
 * `HttpBackend`.
 * 
 * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
 * 
 * \@experimental
 * @abstract
 */
export abstract class HttpHandler {
/**
 * @abstract
 * @param {?} req
 * @return {?}
 */
handle(req: HttpRequest<any>) {}
}
/**
 * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
 * 
 * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
 * 
 * When injected, `HttpBackend` dispatches requests directly to the backend, without going
 * through the interceptor chain.
 * 
 * \@experimental
 * @abstract
 */
export abstract class HttpBackend implements HttpHandler {
/**
 * @abstract
 * @param {?} req
 * @return {?}
 */
handle(req: HttpRequest<any>) {}
}
